import Linkify from 'linkify-react'
import Link from '../common/components/link'

export const urlEncodeEmail = (email: string) => {
  return encodeURIComponent(email).replace(/%40/g, '@')
}

export const convertTextToLinks = (text: string) => {
  return (
    <Linkify
      options={{
        render: ({ attributes, content }) => {
          const { href } = attributes
          return (
            <Link
              onClick={(event) => {
                event.stopPropagation()
              }}
              underline='always'
              href={href}
              target='_blank'
              rel='noopener noreferrer'
              sx={{ wordBreak: 'break-all' }}
            >
              {content}
            </Link>
          )
        },
      }}
    >
      {text}
    </Linkify>
  )
}
